import { render, staticRenderFns } from "./Specialities.vue?vue&type=template&id=4abc30a0&"
import script from "./Specialities.vue?vue&type=script&lang=js&"
export * from "./Specialities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports